module.exports = __webpack_public_path__ + "img/SensorCase.bf8dce9d.png";